export default __webpack_public_path__ + "static/media/E5tCqqYVUAcl4bN.5591ebf6.png";